import React, { useState, useEffect, useMemo } from 'react';
import {
  Container,
} from 'reactstrap';
import { connect } from 'react-redux';
import { IAuthReduxProps, IVisitorTable } from '../../types/interfaces';

// import VisitorEdit from './VisitorEdit';
import VisitorDelete from './VisitorDelete';
import TableContainer from "../tables_manager/TableContainer"
import { DateRangeColumnFilter, SelectColumnFilter } from '../tables_manager/filters';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faClipboard, faExternalLinkAlt, faEye, faFileInvoice, faPen, faPhone, faTrash } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import ReactTooltip from 'react-tooltip';
import LinesEllipsis from 'react-lines-ellipsis'
import { PRIVILEGE } from '../../types/privileges';

const VisitorTable = ({ 
  linesData,
  auth
 }: IVisitorTable) => {
  const skipResetRef = React.useRef(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [modalEditVisitor, setModalEditVisitor] = useState('');
  const [modalDeleteVisitor, setModalDeleteVisitor] = useState('');

  const history = useHistory();
  const alert = useAlert();

  const [copiedFlag, setCopiedFlag] = useState(false);
  const [copiedFlag2, setCopiedFlag2] = useState(false);
  const handleCopy = (e, id = 1) => {
    let phone = (e || "").toString().replace(/ /g,'');
    if(phone.length >= 4 && phone[0] !== "0")
      phone = "+" + phone
    alert.info(`Le numéro de téléphone "${phone}" a été copié.`);
    window.navigator.clipboard.writeText(phone);
    if(id == 1){
      setCopiedFlag(true);
      setTimeout(() => setCopiedFlag(false), 2000);
    }
    else if(id == 2){
      setCopiedFlag2(true);
      setTimeout(() => setCopiedFlag2(false), 2000);
    }
  };

  const viewCard = (e, id) => {
    if(id !== null && id !== undefined){
      if (e.ctrlKey){
        window.open('/fiche_visitor/' + id, '_blank');
        return;
      }
      history.push({ pathname: `/fiche_visitor/${id}` })
    }
  }

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Projet",
        accessor: e => e.societe?.LIBELE || "",
        Filter: SelectColumnFilter,
        Cell: ({ value }) => value || "-",
      },
      {
        Header: "Nom complet",
        accessor: "name",
        Cell: ({ value }) => value || "-"
      },
      {
        Header: "Numéro(s) de Téléphone",
        accessor: "TEL",
        disableSortBy: true,
        Cell: ({ row }) => row.original.TEL || row.original.TEL2 ? <div>
          {row.original.TEL ? <div style={{whiteSpace: "nowrap"}}>
            {row.original.TEL.length >= 4 && row.original.TEL[0] !== "0" ? ("+" + row.original.TEL) : row.original.TEL}
            <a data-tip data-for="telI" href={`tel:${(row.original.TEL.length >= 4 && row.original.TEL[0] !== "0" ? ("+" + row.original.TEL) : row.original.TEL).replace(/ /g,'')}`} style={{marginLeft: "5px", marginRight: "10px"}}><FontAwesomeIcon icon={faPhone} /></a>
            <ReactTooltip effect="solid" place="bottom" id="telI" type="dark"><b>Appeler</b></ReactTooltip>
            <FontAwesomeIcon icon={faClipboard} data-tip data-for="tel" style={{cursor: "pointer"}} onClick={() => handleCopy(row.original.TEL)} />
            <ReactTooltip effect="solid" place="bottom" id="tel" type={copiedFlag ? "success" : "dark"}>
              <FontAwesomeIcon icon={copiedFlag ? faCheckCircle : faClipboard} />&nbsp;&nbsp;{copiedFlag ? "Copié" : "Copier"}
            </ReactTooltip>
          </div> : null}
          {row.original.TEL2 ? <div style={{whiteSpace: "nowrap"}}>
            {row.original.TEL2.length >= 4 && row.original.TEL2[0] !== "0" ? ("+" + row.original.TEL2) : row.original.TEL2}
            <a data-tip data-for="telI2" href={`tel:${(row.original.TEL2.length >= 4 && row.original.TEL2[0] !== "0" ? ("+" + row.original.TEL2) : row.original.TEL2).replace(/ /g,'')}`} style={{marginLeft: "5px", marginRight: "10px"}}><FontAwesomeIcon icon={faPhone} /></a>
            <ReactTooltip effect="solid" place="bottom" id="telI2" type="dark"><b>Appeler</b></ReactTooltip>
            <FontAwesomeIcon icon={faClipboard} data-tip data-for="tel2" style={{cursor: "pointer"}} onClick={() => handleCopy(row.original.TEL2, 2)} />
            <ReactTooltip effect="solid" place="bottom" id="tel2" type={copiedFlag2 ? "success" : "dark"}>
              <FontAwesomeIcon icon={copiedFlag2 ? faCheckCircle : faClipboard} />&nbsp;&nbsp;{copiedFlag2 ? "Copié" : "Copier"}
            </ReactTooltip>
          </div> : null}
        </div> : "-"
      },
      {
        Header: "Ville",
        accessor: "VILLE",
        Cell: ({ value }) => value || "-"
      },
      {
        Header: "Pays",
        accessor: "PAYS",
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Support publicitaire",
        accessor: "SUPPORT_PUB",
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Motif de la visite",
        accessor: "visitReason",
        Cell: ({ value }) => value || "-"
      },
      {
        Header: "Date Visite",
        accessor: "DATE_VISITE",
        customExportDisplay: `$.DATE_VISITE ? new Date($.DATE_VISITE) : "-"`,
        Filter: DateRangeColumnFilter,
        filter: "dateBetween",
        Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-"
      },
      {
        Header: "Saisie le",
        accessor: "createdAt",
        customExportDisplay: `$.createdAt ? new Date($.createdAt).toLocaleString('fr') : ""`,
        Filter: DateRangeColumnFilter,
        filter: "dateBetween",
        // filter: (rows, id, e) => rows.filter(t => t.original[id] && moment(t.original[id]).format('DD/MM/YYYY').includes(e)),
        Cell: ({ value }) => value ? <div title={moment(value).format('DD/MM/YYYY - HH:mm')}>{moment(value).locale('fr').calendar({
            sameDay: '[Aujourd\'hui à] HH:mm',
            nextDay: 'DD/MM/YYYY à HH:mm',
            nextWeek: 'DD/MM/YYYY à HH:mm',
            lastDay: '[Hier à] HH:mm',
            lastWeek: 'DD/MM/YYYY à HH:mm',
            sameElse: 'DD/MM/YYYY à HH:mm'
        })}</div> : "-",
        hidden: true
      },
      {
        Header: "Observation",
        accessor: "comment",
        Cell: ({ value }) => value || "-",
        hidden: true
      }
    ],
    []
  );

  React.useEffect(() => {
    skipResetRef.current = false;
  }, [linesData])

  return (
    <div>
      <Container>
        <TableContainer columns={columns} data={linesData} dataName="visiteurs" enableCheckBox={false} isEditable={false} SubComponent={({ row }) => <span>SubComponent: {row.id}</span>}/>
      </Container>
      {/* <VisitorEdit modal={modalEdit} setModal={setModalEdit} modalData={modalEditVisitor} /> */}
      <VisitorDelete modal={modalDelete} setModal={setModalDelete} modalData={modalDeleteVisitor} />
    </div>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, { })(VisitorTable);
